export const config = (
  translations,
  municipalityNameList,
  autonomousProvinceList
) => {
  const { autonomousProvince, name } = translations || {};

  return {
    fields: [
      {
        key: 1,
        name: 'autonomousProvince',
        type: 'autocomplete',
        label: autonomousProvince,
        optionList: autonomousProvinceList || [],
        getOptionLabel: (autonomousProvinceName) =>
          autonomousProvinceName.text || '',
      },
      {
        key: 2,
        name: 'name',
        type: 'text',
        label: name,
        optionList: municipalityNameList || [],
        getOptionLabel: (municipalityName) => municipalityName || '',
      },
    ],
  };
};
